// extracted by mini-css-extract-plugin
export default {"list":"Agreement_list__QDB8Q","containerButton":"Agreement_containerButton__OsTYN"};